<template>
  <component
    v-bind="$attrs"
    :is="navigateOnSelect ? 'internal-or-external-link' : 'div'"
    style="display: inherit;"
    :href="navigateOnSelect ? siteHref : null"
    @click="trackOrSelectSiteSelection()"
  >
    <q-card
      class="text-left text-decoration-none full-width"
      :class="{
        'q-px-md q-py-sm bg-responsive text-responsive': !showSiteImage,
        [cardColorCss]: showSiteImage
      }"
      :style="{
        'background-color': cardColor === 'custom' ? cardColorHex : undefined,
        'border-radius': showSiteImage ? `${cardBorderRadius}px` : undefined
      }"
      flat
      data-test-id="site-location-zone-card"
    >
      <q-card-section
        class="no-padding"
        :class="{ 'items-center': !showAddress && !showSiteDescription && $_.isNil(site.siteDescription) }"
        :horizontal="!navigateOnSelect"
      >
        <q-card-section
          v-if="!navigateOnSelect"
          class="no-padding"
        >
          <q-checkbox
            v-model="checked"
            val="true"
            class="q-mr-sm"
            @click="selectSiteSelection"
          />
        </q-card-section>
        <q-img
          v-if="showSiteImage && site.siteThumbnailImageUrl"
          :src="site.siteThumbnailImageUrl"
          :alt="`picture of ${site.name}`"
          :ratio="3/2"
          :style="{ 'border-radius': cardColor === 'default' ? `${cardBorderRadius}px` : undefined }"
        />
        <q-card-section
          vertical
          :class="{
            'q-pa-none': !showSiteImage,
            'q-px-none': cardColor === 'default'
          }"
        >
          <div class="text-subtitle1 text-bold inline-block full-width">
            {{ siteName }}
          </div>
          <div
            v-if="showAddress"
            :class="{
              'column': navigateOnSelect,
              'row q-gutter-x-sm': !navigateOnSelect
            }"
          >
            <div
              class="text-subtitle2"
              style="opacity: 0.6;"
            >
              {{ site.address1 }}
            </div>
            <div
              class="text-subtitle2"
              style="opacity: 0.6;"
            >
              {{ site.addressShort }}
            </div>
          </div>

          <div
            v-if="showSiteDescription && !!site.siteDescription"
            class="text-body q-mt-md"
          >
            {{ site.siteDescription }}
          </div>
        </q-card-section>
      </q-card-section>
    </q-card>
  </component>
</template>

<script>
import Site from 'src/models/site/Site'
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'
import SiteSelectorLinkMixin from 'src/modules/consumer/components/mixins/SiteSelectorLinkMixin'

export default {
  name: 'SiteLocationZoneCard',
  components: {
    InternalOrExternalLink
  },
  mixins: [SiteSelectorLinkMixin],
  props: {
    site: {
      type: Site,
      required: true
    },
    showDistance: {
      type: Boolean,
      required: false,
      default: false
    },
    hideAddress: {
      type: Boolean,
      required: false,
      default: false
    },
    showSiteImage: {
      type: Boolean,
      required: false,
      default: false
    },
    showSiteDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    cardColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    cardColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    cardBorderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    redirectHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    navigateOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedLocations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    siteName () {
      return `${this.site.name} ${(this.showDistance && this.site.currentDistanceText) ? '(' + this.site.currentDistanceText + ')' : ''}`
    },
    showAddress () {
      return !this.hideAddress && !_.isNil(this.site.address1) && !_.isNil(this.site.addressShort)
    }
  }
}
</script>

<style scoped>
.site-location-zone-card {
  display: block;
  text-decoration: none;
  color: inherit;
}
</style>
